import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApprovesFeatureKey } from './approves-feature-key';
import { ApprovesState } from './approves.state';
import { CacheableState } from '@utils/cacheable-state';
import { Request } from '@modules/regular-user/requests/domain';
import { first, isNil } from 'lodash';

export const ApprovesFeatureSelector =
  createFeatureSelector<ApprovesState>(ApprovesFeatureKey);
// All Approves
export const allApprovesSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.allApproves;
  }
);
// Pending Approvals
export const pendingRequestToApproveSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.requestsToApprove;
  }
);

// All approvals Count
export const approvalsCountSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.approvalsCount;
  }
);
// All My Approves
export const myApprovesSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.myApproves;
  }
);
// Export Approves
export const exportApprovesSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.exportApproves;
  }
);
// Export Approves
export const requestToApproveByIdSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.requestToApprove;
  }
);
// Approve A Request
export const approveARequestSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.approveARequest;
  }
);
// Deny A Request
export const denyARequestSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.denyARequest;
  }
);
// Get All Approvers
export const approversSelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.approvers;
  }
);

// Get All Approvers By Company
export const approversByCompanySelector = createSelector(
  ApprovesFeatureSelector,
  (state) => {
    return state.approversByCompany;
  }
);

/**
 * All Approves Selector
 */
export const allApprovesSuccessSelector = createSelector(
  allApprovesSelector,
  (state) => {
    return state.data;
  }
);
export const allApprovesFailureSelector = createSelector(
  allApprovesSelector,
  (state) => {
    return state.failure;
  }
);
export const allApprovesLoadingSelector = createSelector(
  allApprovesSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Export Approves Selector
 */
export const exportApprovesSuccessSelector = createSelector(
  exportApprovesSelector,
  (state) => {
    return state.data;
  }
);
export const exportApprovesFailureSelector = createSelector(
  exportApprovesSelector,
  (state) => {
    return state.failure;
  }
);
export const exportApprovesLoadingSelector = createSelector(
  exportApprovesSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Export Approves Selector
 */
export const requestToApproveByIdSuccessSelector = createSelector(
  requestToApproveByIdSelector,
  (state) => {
    return state.data;
  }
);
export const requestToApproveByIdFailureSelector = createSelector(
  requestToApproveByIdSelector,
  (state) => {
    return state.failure;
  }
);
export const requestToApproveIdLoadingSelector = createSelector(
  requestToApproveByIdSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Change Status
 */
export const approveARequestSuccessSelector = createSelector(
  approveARequestSelector,
  (state) => {
    return state.data;
  }
);
export const approveARequestFailureSelector = createSelector(
  approveARequestSelector,
  (state) => {
    return state.failure;
  }
);
export const approveARequestLoadingSelector = createSelector(
  approveARequestSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Change Status
 */
export const denyARequestSuccessSelector = createSelector(
  denyARequestSelector,
  (state) => {
    return state.data;
  }
);
export const denyARequestFailureSelector = createSelector(
  denyARequestSelector,
  (state) => {
    return state.failure;
  }
);
export const denyARequestLoadingSelector = createSelector(
  denyARequestSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Change Status
 */
export const approversSuccessSelector = createSelector(
  approversSelector,
  (state) => {
    return state.data;
  }
);
export const approversFailureSelector = createSelector(
  approversSelector,
  (state) => {
    return state.failure;
  }
);
export const approversLoadingSelector = createSelector(
  approversSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * My Approves
 */
export const myApprovesSuccessSelector = createSelector(
  myApprovesSelector,
  (state) => {
    return state.data;
  }
);
export const myApprovesFailureSelector = createSelector(
  myApprovesSelector,
  (state) => {
    return state.failure;
  }
);
export const myApprovesLoadingSelector = createSelector(
  myApprovesSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * My Approvals Count
 */
export const approvalsCountSuccessSelector = createSelector(
  approvalsCountSelector,
  (state) => {
    return state.data;
  }
);
export const approvalsCountFailureSelector = createSelector(
  approvalsCountSelector,
  (state) => {
    return state.failure;
  }
);
export const approvalsCountLoadingSelector = createSelector(
  approvalsCountSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Pending Approvals
 */
export const pendingRequestToApproveSuccessSelector = createSelector(
  pendingRequestToApproveSelector,
  (state) => {
    return state.data;
  }
);
export const pendingRequestToApproveFailureSelector = createSelector(
  pendingRequestToApproveSelector,
  (state) => {
    return state.failure;
  }
);
export const pendingRequestToApproveLoadingSelector = createSelector(
  pendingRequestToApproveSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Approvers By Id
 */
export const approversByCompanySuccessSelector = createSelector(
  approversByCompanySelector,
  (state) => {
    return state.data;
  }
);
export const approversByCompanyFailureSelector = createSelector(
  approversByCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const approversByCompanyLoadingSelector = createSelector(
  approversByCompanySelector,
  (state) => {
    return state.loading;
  }
);

// Next Pending Request
export const nextRequestToApproveStateSelector = createSelector(
  pendingRequestToApproveSelector,
  requestToApproveByIdSelector,
  (state, current) => {
    const currentId = current.data?.id;
    if (isNil(currentId)) {
      return new CacheableState<Request>();
    }
    let nextRequest: Request | null = null;
    if (state.data) {
      for (let i = 0; i < state.data!.length; i++) {
        const request = state.data![i];
        if (request._id === currentId && i < state.data.length) {
          nextRequest = state.data[i + 1];
          break;
        }
      }
      // if no request have been defined, then pick the first one
      if (isNil(nextRequest) && state.data.length) {
        nextRequest = first(state.data)!;
      }
    }
    let newState = new CacheableState<Request>({
      ...state,
      data: nextRequest,
    });
    return newState;
  }
);
export const nextRequestToApproveSelector = createSelector(
  nextRequestToApproveStateSelector,
  (state) => {
    return state.data;
  }
);
export const nextRequestToApproveLoadingSelector = createSelector(
  nextRequestToApproveStateSelector,
  (state) => {
    return state.loading;
  }
);
